"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var device_1 = require("./device");
exports.Device = device_1.Device;
var user_1 = require("./user");
exports.User = user_1.User;
var media_1 = require("./media");
exports.Media = media_1.Media;
var album_1 = require("./album");
exports.Album = album_1.Album;
var curated_1 = require("./curated");
exports.Curated = curated_1.Curated;
var tag_1 = require("./tag");
exports.Tag = tag_1.Tag;
var category_1 = require("./category");
exports.Category = category_1.Category;
var genre_1 = require("./genre");
exports.Genre = genre_1.Genre;
var playlist_1 = require("./playlist");
exports.Playlist = playlist_1.Playlist;
var contest_1 = require("./contest");
exports.Contest = contest_1.Contest;
var category_media_1 = require("./category_media");
exports.CategoryMedia = category_media_1.CategoryMedia;
var news_feed_item_1 = require("./news_feed_item");
exports.NewsFeedItem = news_feed_item_1.NewsFeedItem;
var news_provider_1 = require("./news_provider");
exports.NewsProvider = news_provider_1.NewsProvider;
var curated_set_1 = require("./curated_set");
exports.CuratedSet = curated_set_1.CuratedSet;
var radio_chart_category_1 = require("./radio_chart_category");
exports.RadioChartCategory = radio_chart_category_1.RadioChartCategory;
var podcast_1 = require("./podcast");
exports.Podcast = podcast_1.Podcast;
var podcast_category_1 = require("./podcast_category");
exports.PodcastCategory = podcast_category_1.PodcastCategory;
var bpmplaylist_1 = require("./bpmplaylist");
exports.BPMPlaylist = bpmplaylist_1.BPMPlaylist;
var bpmplaylist_category_1 = require("./bpmplaylist_category");
exports.BPMPlaylistCategory = bpmplaylist_category_1.BPMPlaylistCategory;
var curated_category_1 = require("./curated_category");
exports.CuratedCategory = curated_category_1.default;
var playlist_provider_1 = require("./playlist_provider");
exports.PlaylistProvider = playlist_provider_1.PlaylistProvider;
const jsonparser_1 = require("../requests/jsonparser");
function generateRealmModels() {
    let schemas = new Array();
    Object.keys(jsonparser_1.fullJsonRegistry).forEach((key) => {
        if (key === 'BaseModel') {
            return;
        }
        let object = Object.assign({}, jsonparser_1.fullJsonRegistry[key]);
        if (jsonparser_1.fullJsonRegistry[key].isHelperModel === false) {
            object.properties = Object.assign(object.properties, jsonparser_1.fullJsonRegistry['BaseModel'].properties);
        }
        let mappedObject = {};
        Object.keys(object.properties).forEach((key) => {
            if (key === 'id') {
                mappedObject[key] = { 'type': 'string', unique: true };
                return;
            }
            if (typeof object.properties[key] === 'string') {
                switch (object.properties[key].toLowerCase()) {
                    case 'boolean':
                        mappedObject[key] = 'bool';
                        break;
                    case 'boolean?':
                        mappedObject[key] = 'bool?';
                        break;
                    case 'number':
                        mappedObject[key] = 'float';
                        break;
                    case 'number?':
                        mappedObject[key] = 'float?';
                        break;
                    case 'string':
                        mappedObject[key] = 'string';
                        break;
                    case 'string?':
                        mappedObject[key] = 'string?';
                        break;
                    case 'number[]':
                        mappedObject[key] = 'float[]';
                        break;
                    default:
                        mappedObject[key] = object.properties[key];
                        break;
                }
            }
        });
        let scheme = {
            name: jsonparser_1.fullJsonRegistry[key].modelName,
            properties: mappedObject
        };
        if (jsonparser_1.fullJsonRegistry[key].isHelperModel === false) {
            scheme.primaryKey = 'id';
        }
        schemas.push(scheme);
    });
    return schemas;
}
exports.generateRealmModels = generateRealmModels;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/models/index.js
// module id = 86
// module chunks = 0